/* eslint-disable */
import {
	makeApiRequest,
} from './helpers.js'
import {
	subscribeOnStream,
	unsubscribeFromStream,
} from './streaming.js'

const lastBarsCache = new Map()

const quotePricePrecision = {
	USDT: 2,
	TMN: 0,
	IRT: 0,
}

const basePricePrecision = {
	SHIB: 8,
	DOGE: 5,
	TRX: 5,
	ADA: 5,
	SUI: 5,
	XLM: 5,
	HBAR: 6,
	CHZ: 5,
	APE: 5,
	BAT: 6,
	ENJ: 6,
	FIL: 6,
	CRV: 6,
	LDO: 6,
	ARB: 6,
	A: 5,
	POL: 5,
	MANA: 5,
	DYDX: 5,
	SUSHI: 5,
	ALGO: 5,
	SAND: 5,
}

function getPositiveNumber(value) {
	const numberValue = Number(value)
	return Number.isFinite(numberValue) && numberValue > 0 ? numberValue : null
}

function getPriceDecimals(value) {
	if (value === '' || value === null || value === undefined) {
		return null
	}

	const stringValue = String(value).toLowerCase()

	if (stringValue.includes('e-')) {
		return Number(stringValue.split('e-')[1]) || 0
	}

	const decimals = stringValue.split('.')[1]
	return decimals ? decimals.replace(/0+$/, '').length : 0
}

function getSymbolPriceFormat(symbolItem) {
	const [base, quote] = symbolItem.symbol.split("/")
	const explicitPriceScale = getPositiveNumber(
		symbolItem.pricescale ??
		symbolItem.priceScale ??
		symbolItem.price_scale
	)
	const precision = getPositiveNumber(
		symbolItem.pricePrecision ??
		symbolItem.price_precision ??
		symbolItem.precision
	)
	const fallbackPrecision =
		precision ??
		getPriceDecimals(symbolItem.price ?? symbolItem.last_price ?? symbolItem.lastPrice ?? symbolItem.last ?? symbolItem.close ?? '') ??
		basePricePrecision[base] ??
		quotePricePrecision[quote] ??
		0
	const pricescale = explicitPriceScale || Math.pow(10, Math.min(fallbackPrecision, 8))
	const minMove = getPositiveNumber(symbolItem.minmov) || 1
	const tickSize = getPositiveNumber(symbolItem.minMove ?? symbolItem.min_move)

	if (tickSize) {
		return {
			minMove: Math.max(1, Math.round(tickSize * pricescale)),
			pricescale,
		}
	}

	return {
		minMove,
		pricescale,
	}
}

const configurationData = {
	supported_resolutions: ["60"],
	left_toolbar: "off",
	exchanges: [
		{
			value: 'Arzypto',
			name: 'Arzypto',
			desc: 'Arzypto'
		}
	],
	symbols_types: [
		{
			name: 'crypto',
			value: 'crypto',
		}
	]
}

// Obtains all symbols for all exchanges supported by CryptoCompare API
async function getAllSymbols(arzyptoType) {
	try {
		if (arzyptoType == 'ARZYPTO_EXCHANGE') {
			let response = await fetch(`https://www.arzypto.com/api/exchange/market/list?quote=` + urlParams.get('pair').split('_').pop())
			const result = await response.json();
			let list = []

			result.data.markets.forEach((market) => {
				let pair = market.base + "/" + market.quote //"USDT/IRT"
				list.push({
					description: pair,
					exchange: "Arzypto",
					full_name: "Arzypto:" + pair,
					symbol: pair,
					type: "Exchange",
					minmov: market.minmov,
					minMove: market.minMove,
					min_move: market.min_move,
					precision: market.precision,
					pricePrecision: market.pricePrecision,
					price_precision: market.price_precision,
					price: market.price,
					last_price: market.last_price,
					lastPrice: market.lastPrice,
					last: market.last,
					close: market.close,
					pricescale: market.pricescale,
					priceScale: market.priceScale,
					price_scale: market.price_scale,
				})
			})

			return list
		} else {
			return [{
				description: "USDT/TMN",
				exchange: "Arzypto",
				full_name: "Arzypto:USDT/TMN",
				symbol: "USDT/TMN",
				type: "crypto",
			}]
		}
	} catch (error) {
		return [{
			description: "USDT/TMN",
			exchange: "Arzypto",
			full_name: "Arzypto:USDT/TMN",
			symbol: "USDT/TMN",
			type: "crypto",
		}]
	}
}

export default {
	onReady: (callback) => {
		// console.log('[onReady]: Method call')
		setTimeout(() => callback(configurationData))
	},

	searchSymbols: async (
		userInput,
		exchange,
		symbolType,
		onResultReadyCallback,
	) => {
		// console.log('[searchSymbols]: Method call')
		const symbols = await getAllSymbols(urlParams.get('type'))
		const newSymbols = symbols.filter(symbol => {
			const isExchangeValid = exchange === '' || symbol.exchange === exchange
			const isFullSymbolContainsInput = symbol.full_name
				.toLowerCase()
				.indexOf(userInput.toLowerCase()) !== -1
			return isExchangeValid && isFullSymbolContainsInput
		})
		onResultReadyCallback(newSymbols)
	},

	resolveSymbol: async (
		symbolName,
		onSymbolResolvedCallback,
		onResolveErrorCallback,
		extension
	) => {
		// console.log('[resolveSymbol]: Method call', symbolName)
		const symbols = await getAllSymbols(urlParams.get('type'))
		const symbolItem = symbols.find(({
			full_name,
		}) => full_name === symbolName)

		if (!symbolItem) {
			// console.log('[resolveSymbol]: Cannot resolve symbol', symbolName)
			onResolveErrorCallback('cannot resolve symbol')
			return
		}

		const {
			minMove,
			pricescale,
		} = getSymbolPriceFormat(symbolItem)

		const symbolInfo = {			
			ticker: symbolItem.full_name,
			name: symbolItem.symbol,
			description: symbolItem.description,
			type: symbolItem.type,
			session: "24x7",
			timezone: "Asia/Tehran",
			exchange: symbolItem.exchange,
			autoScale: true,
			minmov: minMove,
			pricescale: pricescale,
			has_intraday: true,
			create_volume_indicator_by_default: 'no',
			has_weekly_and_monthly: false,
			supported_resolutions: configurationData.supported_resolutions,
			volume_precision: 1,
			data_status: 'streaming',
		}

		// console.log('[resolveSymbol]: Symbol resolved', symbolName)
		onSymbolResolvedCallback(symbolInfo)
	},

	getBars: async (symbolInfo, resolution, periodParams, onHistoryCallback, onErrorCallback) => {
		const { from, to, countBack, firstDataRequest } = periodParams
		const market = symbolInfo.name.replace("/", "_")

		try {
			const urlParams = new URLSearchParams(window.location.search)		
			const url = `?market=${market}&from=${from}&to=${to}&countback=${countBack}`
			const data = await makeApiRequest(urlParams.get('type'), url)
			if (data.s != 'ok' || data.t.length === 0) {
				// "noData" should be set if there is no data in the requested period
				onHistoryCallback([], {
					noData: true,
				})
				return
			}

			let bars = []
			let noData = true
			// let bars = []

			for (let i = 0; i < data.t.length; i++) {
			bars.push({
				time: (data.t[i] * 1000),
				open: data.o[i] ?? data.c[i],
				high: data.h[i] ?? data.c[i],
				low: data.l[i] ?? data.c[i],
				close: data.c[i] ?? data.o[i],
			})
}

			if (firstDataRequest) {
				lastBarsCache.set(symbolInfo.full_name, {
					...bars[bars.length - 1],
				})
			}
			// console.log(`[getBars]: returned ${bars.length} bar(s)`)
			onHistoryCallback(bars, {
				noData: false,
			})

			if (noData) {
				onErrorCallback("no data")
			}
		} catch (error) {
			console.log('[getBars]: Get error', error)
			onErrorCallback(error)
		}
	},

	subscribeBars: (
		symbolInfo,
		resolution,
		onRealtimeCallback,
		subscriberUID,
		onResetCacheNeededCallback,
	) => {
		// console.log('[subscribeBars]: Method call with subscriberUID:', subscriberUID)
		subscribeOnStream(
			symbolInfo,
			resolution,
			onRealtimeCallback,
			subscriberUID,
			onResetCacheNeededCallback,
			lastBarsCache.get(symbolInfo.full_name),
		)
	},

	unsubscribeBars: (subscriberUID) => {
		// console.log('[unsubscribeBars]: Method call with subscriberUID:', subscriberUID)
		unsubscribeFromStream(subscriberUID)
	}
}
/* eslint-disable */
